export default __webpack_public_path__ + "static/media/ic_gmx_footer.1d64ea5c.svg";